// extracted by mini-css-extract-plugin
export default {"imgWrapper":"ProfileImage_imgWrapper__Ny40t"};